import React, { useEffect } from "react"
import * as R from 'ramda'

import G from '../../util/globalFunction'
import tremSession from '../../util/tremSession'
import ModalBox, {usePopup} from '../../components/modalBox'

export default props =>{

    const companyCheckPopupProps = usePopup('알림')
    const companyCheckPopupButtons = [
       {
           title:'등록하기',
           handler:()=>{
               G.gotoPage("/home/collabi/myPage/user/info")
           }
       }
    ]

    useEffect(() => {
        const currentUrl  = window.location.pathname
        const currentUrlCheck = currentUrl.includes("/home/collabi/myPage/user/info")
        tremSession.getSessinInfo().then(data => {
            //개인이용자일 때 부서키 없어도 부서등록 팝업x
            data?.loggined===true&&
            (R.isNil(data?.COMPANY_SKEY)===true||
            (R.isNil(data?.DEPT_SKEY)===true && data?.COMPANY_DIV !== "03"))&&
            !currentUrlCheck&&
            companyCheckPopupProps.setOpen(true)
        })
    })

    return (
        companyCheckPopupProps.open &&
        <ModalBox {...companyCheckPopupProps} handleClose={()=>{alert(G.t('trem.lang.home.0958'))}} buttons={companyCheckPopupButtons} width="600" height="300">
            <div className="main_company_check_popup" style={{marginTop:"35px"}}>
                <div style={{textAlign:'center'}}>
                    <p>
                        장비, 시설, 교육 예약을 위해 소속정보가 필요합니다.
                        <br/>
                        소속정보 등록을 위해 회원정보페이지로 이동합니다.
                    </p>
                </div>
            </div>
        </ModalBox>
    )
}